<template>
  <div id="app" :class="{'showScrollBarX': showScrollBarX}">
    <transition name="el-fade-in-linear">
      <router-view />
    </transition>
  </div>
</template>

<script>
  export default {
    name: "APP",
    created() {
      if(sessionStorage.getItem("login-user-info") != null) {
        this.$store.dispatch("loadAllDict");
      }
    },
    computed: {
      showScrollBarX() {
        return this.$store.state.showScrollBarX;
      }
    }
  }
</script>

<style lang="scss">
  * {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    margin: 0;
    padding: 0;
  }

  .showScrollBarX {
    .tab-view {
      .ps {
        overflow-y: hidden !important;
        overflow-x: auto !important;
      }
      .scroller {
        padding-bottom: 12px !important;
      }
    }
  }

  html, body, #app {
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .table-row-cell{
    background-color: #EBEEF5!important;
  }

  .fb-el-link{
    margin-right: 10px;
  }



  /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #eaecf1;
    border-radius: 3px;
  }


  .row-style {
    width: 100%;
    padding: 2px;
  }

  .el-image {
    width: 70px;
    height: 70px;
    border-radius: 10px;
  }




</style>
